<template>
  <div
    style="min-height: calc(100vh - 160px)"
    v-loading="homeLoading"
    element-loading-text="数据处理中......"
  >
    <div class="title">
      <div class="title--newFont">
        <span v-if="finish_type == 0">{{ $t("新增委外收货") }}</span>
        <span v-if="finish_type == 1">{{ $t("修改委外收货") }}</span>
      </div>
      <div style="text-align: right">
        <el-button size="mini" class="btnOne" @click="saveData">{{
          $t("提交")
        }}</el-button>
        <el-button size="mini" class="btnTwo" @click="backHome">{{
          $t("返回")
        }}</el-button>
      </div>
    </div>
    <hr />
    <!-- 内容 -->
    <div>
      <myTable
        :id="'myTableOne'"
        :columnType="'columnIndex'"
        :list="itemList"
        :titleList="itemTitleList"
        :tableBtnList="itemTableBtnList"
        @btnClick="productBtnClick"
        @inputNumberClick="inputNumberClick"
        ref="myTableOne"
      ></myTable>
    </div>
    <!-- 质检单 -->
  </div>
</template>
<script>
import {
  divFloat,
  mulFloat,
  accAdd,
  subFloat,
  year,
  month,
  day,
  _debounce,
} from "@/utils/myUtils";
import {
  outsourcingtowarehouse_add,
  outsourcingtowarehouse_update,
} from "@/api/myController/outsourcing";
export default {
  props: {
    // 页面传进来判断的值
    routeType: {
      type: Array,
      default: undefined,
    },
    // 页面传进来的值
    routeQuery: {
      default: () => ({}),
    },
    finish_type: {
      type: Number,
      default: 0,
    },
    itemList: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
    // 新增数据
    addData: {
      default: () => ({}),
    },
  },
  components: {},
  data() {
    return {
      btnLoading: false,
      homeLoading: false,
      // ------------------基础数据
      proList: [],
      itemTableBtnList: [],
      itemTitleList: [
        {
          id: 1,
          name: this.$t("关联单号"),
          value: "outsourcingDocNumber",
          fixedState: false,
          isShow: true,
          dataType: "text",
          selectOptionKey: "",
          selectOptionList: [],
          canEdit: false,
          width: 150,
        },
        // {
        //   id: 1,
        //   name: this.$t("收货单号"),
        //   value: "outsourcingtowarehouseNumber",
        //   fixedState: false,
        //   isShow: true,
        //   dataType: "text",
        //   selectOptionKey: "",
        //   selectOptionList: [],
        //   alwaysEditState: true,
        //   canEdit: true,
        //   width: 150,
        // },
        {
          id: 1,
          name: this.$t("全局搜索码"),
          value: "globalSearchNumber",
          fixedState: false,
          isShow: true,
          dataType: "text",
          selectOptionKey: "",
          selectOptionList: [],
          canEdit: false,
          width: 150,
        },
        {
          id: 3,
          name: this.$t("产品编号"),
          value: "baseMaterialNumber",
          fixedState: false,
          isShow: true,
          dataType: "text",
          selectOptionKey: "",
          selectOptionList: [],
          canEdit: false,
          width: 150,
        },
        {
          id: 4,
          name: this.$t("产品名称"),
          value: "baseMaterialName",
          fixedState: false,
          isShow: true,
          dataType: "text",
          selectOptionKey: "",
          selectOptionList: [],
          canEdit: false,
          width: 150,
        },
        {
          id: 2,
          name: this.$t("规格型号"),
          value: "specifications",
          fixedState: false,
          isShow: true,
          dataType: "textList",
          alwaysEditState: false,
          canEdit: false,
          width: 200,
        },
        {
          id: 2,
          name: this.$t("客户料号"),
          value: "baseCustomerMaterialNumber",
          fixedState: false,
          isShow: true,
          dataType: "text",
          alwaysEditState: false,
          canEdit: false,
          width: 120,
        },
        {
          id: 9,
          name: this.$t("本次收货数量"),
          value: "baseOutsourcingFinishedQuantity",
          fixedState: false,
          isShow: true,
          dataType: "number",
          canEdit: true,
          alwaysEditState: true,
          width: 120,
        },
        {
          id: 9,
          name: this.$t("收货日期"),
          value: "baseInwarehouseTime",
          fixedState: false,
          isShow: true,
          dataType: "dateTime",
          canEdit: true,
          alwaysEditState: true,
          width: 180,
        },
        {
          id: 11,
          name: this.$t("备注"),
          value: "remark",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: true,
          alwaysEditState: true,
          width: 180,
        },
      ],
      // 转单数据
      sysDocRelationDto: {
        baseMaterialFromPrice: 0,
        baseMaterialId: 0,
        baseMaterialSpecgroupId: 0,
        baseMaterialToPrice: 0,
        createDeptId: 0,
        relationDocDetailFromId: 0,
        relationDocDetailToId: 0,
        relationDocFromId: 0, //来源单据ID
        relationDocToId: 0,
        relationId: 0,
        relationType: 0, //0.不正常，2.正常
        remark: "",
        searchString: "",
        valueMaterialQuantity: 0,
      },
    };
  },
  async created() {
    if (this.routeType && this.routeType == 1) {
      this.onlyHandle(this.routeQuery);
    }
  },
  methods: {
    // 多语言
    $t(value) {
      return value;
    },
    // 单个单据收货
    async onlyHandle(row) {
      this.itemList = [];
      let item = row;
      // 转单数据
      item.sysDocRelationDto = {
        baseMaterialFromPrice: 0,
        baseMaterialId: 0,
        baseMaterialSpecgroupId: 0,
        baseMaterialToPrice: 0,
        createDeptId: 0,
        relationDocDetailFromId: 0,
        relationDocDetailToId: 0,
        relationDocFromId: item.outsourcingDocId, //来源单据ID
        relationDocToId: 0,
        relationId: 0,
        relationType: 0, //0.不正常，2.正常
        remark: "",
        searchString: "",
        valueMaterialQuantity: 0,
      };
      item.baseSpecgroupId = item.baseMaterialSpecgroupId;
      try {
        item.specifications = JSON.parse(item.baseMaterialSpecDesc);
      } catch (error) {}
      item.baseQualifiedWarehouseName = item.baseOutsorWarehouseName;
      item.baseQualifiedWarehouseId = item.baseOutsorWarehouseId;
      item.baseInwarehouseTime = year() + "-" + month() + "-" + day();
      item.baseInwarehouseQuantity = subFloat(
        item.baseOutsourcingQuantity,
        item.valueLockInwarehouseQuantity
      );
      item.baseFinishedQuantity = item.baseInwarehouseQuantity;
      item.valueQualifiedQuantity = item.valueUnfinishedQuantity;
      item.baseOutsourcingFinishedQuantity = item.valueUnfinishedQuantity;
      item.valueUnqualifiedQuantity = 0;
      try {
        if (parseFloat(item.baseInwarehouseQuantity) < 0) {
          item.baseInwarehouseQuantity = 1;
        }
      } catch (error) {
        item.baseInwarehouseQuantity = 1;
        item.baseFinishedQuantity = 1;
        item.valueQualifiedQuantity = 1;
        item.baseOutsourcingFinishedQuantity = 1;
      }
      item.outsourcingtowarehouseNumber = null;
      this.itemList.push(item);
      this.itemList = JSON.parse(JSON.stringify(this.itemList));
    },
    inputNumberClick(row, val) {
      switch (val) {
        case "baseOutsourcingFinishedQuantity":
          row.baseMaterialTotalprice = mulFloat(
            row.baseOutsourcingFinishedQuantity,
            row.baseMaterialUnitprice
          );
          row.baseMaterialTotalpriceUntaxed = mulFloat(
            row.baseOutsourcingFinishedQuantity,
            row.baseMaterialUnitpriceUntaxed
          );
          break;
        default:
          break;
      }
    },
    productBtnClick(row, item, index, state) {
      switch (item) {
        case this.$t("删除"):
          this.itemList.splice(index - 1, 1);
          break;
        default:
          break;
      }
    },
    async saveData() {
      if (this.itemList.length == 0) {
        this.$message.error(this.$t("请选择产品"));
        return;
      }
      this.itemList.forEach((item) => {
        item.baseOutsourcingDocId = item.outsourcingDocId;
        item.baseMetaUnitId = item.baseMaterialUnitId;
        item.baseoutsourcingId = item.outsourcingDocId;
        item.baseoutsourcingDocNumber = item.outsourcingDocNumber;
        item.baseSpecgroupDesc = item.baseMaterialSpecDesc;
        item.baseSpecgroupId = item.baseMaterialSpecgroupId;
        item.statusCheck = 0;
        item.statusDoc = 0;
      });
      let json = {
        outsourcingtowarehouseDto: this.itemList[0],
      };
      if (this.finish_type == 0) {
        outsourcingtowarehouse_add(json).then((res) => {
          this.$message.success(this.$t("操作成功") + "！");
          let json = {
            outsourcingtowarehouseId: res.data.data,
          };
          this.$emit("backHome", 50, json);
        });
      } else {
        outsourcingtowarehouse_update(json).then((res) => {
          this.$message.success(this.$t("操作成功") + "！");
          this.$emit("backOrderState");
        });
      }
    },
    backHome() {
      this.$emit("backHome");
    },
  },
};
</script>
<style scoped>
::v-deep .el-descriptions-item__cell .el-descriptions-item__label .is-bordered-label {
  width: 120px !important;
}
.input {
  width: 100%;
}

.btnOne {
  background: #08a1b8;
  color: white;
}

.title {
  display: flex;
  position: relative;
  margin-bottom: 10px;
}

.title----font {
  color: rgb(8, 161, 184);
  position: relative;
  margin-left: 47%;
  font-size: 25px;
  font-weight: bold;
}

.title--button {
  position: absolute;
  margin-left: 1px;
  margin-top: 0.1%;
}
</style>
